import React from 'react'
import { MainPageProps } from 'src/pages/MainPage/index'
import styled from 'styled-components'
import { Container } from 'src/components/common/Container'

import MainTopBanner from 'src/pages/MainPage/_components/MainTopBanner'
import MainCategoryShortcut from 'src/pages/MainPage/_components/MainCategoryShortcut'
import MainMapShortcut from 'src/pages/MainPage/_components/MainMapShortcut'
import MainHotDealCoupon from 'src/pages/MainPage/_components/MainHotDealCoupon'
import MainFreeCouponShortcut from 'src/pages/MainPage/_components/MainFreeCouponShortcut'
import MainPopularCoupon from 'src/pages/MainPage/_components/MainPopularCoupon'
import HighViewedCoupon from 'src/pages/MainPage/_components/HighViewedCoupon'
import MainRecommendBrand from 'src/pages/MainPage/_components/MainRecommendBrand'
import MainMdPickCoupon from 'src/pages/MainPage/_components/MainMdPickCoupon'

const MainPageView = (props: MainPageProps) => {
  return (
    <S.MainContainer $option="flex_column" $row_gap="30px">
      <MainTopBanner {...props} />
      <MainCategoryShortcut {...props} />
      <MainMapShortcut />
      <MainHotDealCoupon {...props} />
      <MainFreeCouponShortcut />
      <MainPopularCoupon {...props} />
      <HighViewedCoupon {...props} />
      <MainRecommendBrand {...props} />
      <MainMdPickCoupon {...props} />
    </S.MainContainer>
  )
}

export default MainPageView

const S = {
  MainContainer: styled(Container)`
    margin-top: 40px;
    max-width: 688px;
    width: 100%;
    align-items: center;
    padding-bottom: 50px;
    overflow-x: hidden;
  `,
}
